import { ref } from 'vue';
import { storefrontRequest } from '@/lib/storefront-api';

export function useNewsletterForm() {
  const email = ref('');
  const loading = ref(false);
  const successMessage = ref('');
  const errorMessage = ref('');

  const submit = async () => {
    successMessage.value = '';
    errorMessage.value = '';

    if (!email.value.trim()) {
      errorMessage.value = 'Please enter your email address.';
      return false;
    }

    loading.value = true;

    try {
      const response = await storefrontRequest('/newsletter-subscriptions', {
        method: 'POST',
        data: { email: email.value.trim() },
      });

      successMessage.value = response.message || 'You have been subscribed to the newsletter.';
      email.value = '';
      return true;
    } catch (error) {
      errorMessage.value = error.errors?.email?.[0] || error.message || 'Unable to subscribe right now.';
      return false;
    } finally {
      loading.value = false;
    }
  };

  return {
    email,
    loading,
    successMessage,
    errorMessage,
    submit,
  };
}
